import React from 'react';
import './PoliticaPrivacidade.css';
import BotaoVoltar from '../../componentes/BotaoVoltar';

const PoliticaPrivacidade = () => {
    return (
        <main className="politica-privacidade">
            <div className="politica-privacidade__container">

                <nav className="politica-privacidade__navegacao" aria-label="Navegação">
                    <BotaoVoltar />
                </nav>

                <header className="politica-privacidade__cabecalho">
                    <h1 className="politica-privacidade__titulo">Política de Privacidade</h1>
                    <div className="politica-privacidade__meta">
                        Última atualização: 19 de setembro de 2026
                    </div>
                    <p className="politica-privacidade__introducao">
                        Bem-vindo ao <strong>Viver Espírita</strong>. Nós valorizamos a sua privacidade e temos o compromisso 
                        de proteger os seus dados pessoais com transparência, respeito e integridade, em estrita conformidade 
                        com a <strong>Lei Geral de Proteção de Dados Pessoais (LGPD — Lei nº 13.709/2018)</strong> e o 
                        <strong> Marco Civil da Internet (Lei nº 12.965/2014)</strong>.
                    </p>
                </header>

                <section className="politica-privacidade__secao">
                    <h2 className="politica-privacidade__subtitulo">1. Informações Gerais e Controlador dos Dados</h2>
                    <p className="politica-privacidade__texto">
                        Para os fins desta Política de Privacidade e da legislação aplicável, o portal <strong>Viver Espírita</strong> atua 
                        como Controlador dos seus dados pessoais coletados neste site. Nosso objetivo primordial é o estudo e a 
                        divulgação da Doutrina Espírita e dos ensinamentos morais de Jesus de forma fraterna e sem fins lucrativos.
                    </p>
                </section>

                <section className="politica-privacidade__secao">
                    <h2 className="politica-privacidade__subtitulo">2. Informações que Coletamos</h2>
                    
                    <h3 className="politica-privacidade__topico">2.1. Dados Fornecidos Diretamente por Você:</h3>
                    <p className="politica-privacidade__texto">
                        Ao realizar o seu cadastro ou interagir em nosso portal, podemos coletar:
                    </p>
                    <ul className="politica-privacidade__lista">
                        <li><strong>Dados de Identificação e Acesso:</strong> Nome completo, endereço de e-mail e senha de acesso.</li>
                        <li><strong>Foto de Perfil (Opcional):</strong> Imagem enviada voluntariamente para personalização do seu perfil.</li>
                        <li><strong>Preferências de Comunicação:</strong> Opção de autorização para receber informativos e notificações por e-mail.</li>
                    </ul>

                    <h3 className="politica-privacidade__topico">2.2. Dados de Interação no Fórum e Artigos:</h3>
                    <p className="politica-privacidade__texto">
                        Tópicos, dúvidas, respostas e comentários enviados voluntariamente por você no Fórum de Estudos ou nas 
                        publicações do site.
                    </p>

                    <h3 className="politica-privacidade__topico">2.3. Dados Coletados Automaticamente (Registros de Conexão):</h3>
                    <p className="politica-privacidade__texto">
                        Em cumprimento ao artigo 15 da Lei nº 12.965/2014 (Marco Civil da Internet), coletamos e armazenamos 
                        automaticamente registros de acesso à aplicação, tais como:
                    </p>
                    <ul className="politica-privacidade__lista">
                        <li>Endereço IP de origem.</li>
                        <li>Data, hora e fuso horário do acesso.</li>
                        <li>Informações sobre o dispositivo e navegador utilizado.</li>
                    </ul>
                </section>

                <section className="politica-privacidade__secao">
                    <h2 className="politica-privacidade__subtitulo">3. Finalidades e Bases Legais do Tratamento</h2>
                    <p className="politica-privacidade__texto">
                        O tratamento dos seus dados pessoais possui finalidades claras e fundamenta-se nas bases legais da LGPD (Art. 7º):
                    </p>
                    <ul className="politica-privacidade__lista">
                        <li>
                            <strong>Prestação dos Serviços e Acesso à Conta (Art. 7º, V):</strong> Permitir a criação de conta, autenticação segura, 
                            participação no Fórum de Estudos, postagem de mensagens e envio de comentários em artigos.
                        </li>
                        <li>
                            <strong>Ativação de Conta e Recuperação de Acesso (Art. 7º, V):</strong> Envio de e-mails para validação de cadastro 
                            e redefinição de senha caso solicitada.
                        </li>
                        <li>
                            <strong>Envio de Informativos e Notificações (Art. 7º, I - Consentimento):</strong> Envio de e-mails com atualizações 
                            de novos artigos ou atividades do fórum, realizado apenas mediante sua autorização prévia (a qual pode ser 
                            revogada a qualquer momento).
                        </li>
                        <li>
                            <strong>Cumprimento de Obrigação Legal (Art. 7º, II):</strong> Guarda obrigatória de registros de conexão conforme 
                            exigido pelo Marco Civil da Internet.
                        </li>
                        <li>
                            <strong>Segurança e Prevenção a Fraudes (Art. 7º, IX - Legítimo Interesse):</strong> Garantir a estabilidade do site, 
                            moderar conteúdos ofensivos e proteger nossa comunidade contra spam e acessos indevidos.
                        </li>
                    </ul>
                </section>

                <section className="politica-privacidade__secao">
                    <h2 className="politica-privacidade__subtitulo">4. Compartilhamento de Dados</h2>
                    <p className="politica-privacidade__texto">
                        <strong>Nós não vendemos, não alugamos e não comercializamos dados pessoais de nossos usuários em nenhuma hipótese.</strong>
                    </p>
                    <p className="politica-privacidade__texto">
                        O compartilhamento de dados ocorre apenas nas seguintes situações estritamente necessárias:
                    </p>
                    <ul className="politica-privacidade__lista">
                        <li>
                            <strong>Provedores Técnicos e de Infraestrutura:</strong> Serviços de hospedagem em nuvem, servidores de banco de 
                            dados seguros e serviços de envio de e-mails transacionais necessários ao funcionamento do site.
                        </li>
                        <li>
                            <strong>Ferramentas de Proteção (ex: Google reCAPTCHA):</strong> Para verificar se as requisições partem de pessoas reais 
                            e prevenir ataques automatizados e spam.
                        </li>
                        <li>
                            <strong>Obrigação Legal ou Ordem Judicial:</strong> Para cumprimento de ordens judiciais emitidas por autoridades competentes 
                            ou determinações legais previstas em lei.
                        </li>
                    </ul>
                </section>

                <section className="politica-privacidade__secao">
                    <h2 className="politica-privacidade__subtitulo">5. Segurança e Armazenamento dos Dados</h2>
                    <p className="politica-privacidade__texto">
                        Adotamos medidas técnicas e organizacionais adequadas para proteger os seus dados contra acessos não autorizados, 
                        destruição, perda ou alteração ilícita:
                    </p>
                    <ul className="politica-privacidade__lista">
                        <li>Comunicação inteiramente protegida via criptografia SSL/TLS (protocolo HTTPS seguro).</li>
                        <li>Senhas armazenadas em banco de dados exclusivamente sob formato de hash criptográfico unidirecional seguro (sua senha nunca é armazenada em texto puro).</li>
                        <li>Ambiente de banco de dados com acesso restrito e autenticado.</li>
                    </ul>
                    <p className="politica-privacidade__texto">
                        Seus dados são mantidos enquanto o seu cadastro estiver ativo em nossa plataforma ou pelo período estritamente 
                        necessário para cumprimento de obrigações legais (como os 6 meses de registros de conexão exigidos pelo Marco Civil da Internet).
                    </p>
                </section>

                <section className="politica-privacidade__secao">
                    <h2 className="politica-privacidade__subtitulo">6. Uso de Cookies</h2>
                    <p className="politica-privacidade__texto">
                        Utilizamos cookies e tecnologias similares de armazenamento local (LocalStorage) estritamente necessários para:
                    </p>
                    <ul className="politica-privacidade__lista">
                        <li>Manter a sua sessão autenticada (armazenamento do token de acesso seguro durante sua navegação).</li>
                        <li>Garantir a integridade das requisições e a segurança contra formulários automatizados.</li>
                    </ul>
                    <p className="politica-privacidade__texto">
                        Você pode, a qualquer momento, desativar ou limpar os cookies através das configurações do seu navegador web. Contudo, 
                        a desativação de cookies essenciais poderá inviabilizar o login e certas áreas interativas do site.
                    </p>
                </section>

                <section className="politica-privacidade__secao">
                    <h2 className="politica-privacidade__subtitulo">7. Seus Direitos como Titular de Dados (LGPD)</h2>
                    <p className="politica-privacidade__texto">
                        Em conformidade com o artigo 18 da LGPD, você possui os seguintes direitos em relação aos seus dados pessoais:
                    </p>
                    <ul className="politica-privacidade__lista">
                        <li><strong>Confirmação e Acesso:</strong> Confirmar a existência de tratamento e acessar os dados que possuímos sobre você.</li>
                        <li><strong>Correção:</strong> Solicitar a correção ou atualização de dados incompletos, inexatos ou desatualizados (muitos desses campos podem ser alterados diretamente no seu painel "Meus Dados").</li>
                        <li><strong>Revogação do Consentimento:</strong> Desmarcar a qualquer momento o recebimento de e-mails informativos através do seu perfil.</li>
                        <li><strong>Eliminação dos Dados:</strong> Solicitar a exclusão definitiva do seu cadastro e dados pessoais do nosso banco de dados, ressalvadas as hipóteses de guarda obrigatória por lei.</li>
                    </ul>
                </section>

                <section className="politica-privacidade__secao">
                    <h2 className="politica-privacidade__subtitulo">8. Canal de Contato e Encarregado de Dados</h2>
                    <p className="politica-privacidade__texto">
                        Caso deseje exercer qualquer um dos seus direitos como titular de dados, esclarecer dúvidas sobre esta Política de Privacidade 
                        ou solicitar informações adicionais, entre em contato direto com a nossa equipe:
                    </p>
                    <div className="politica-privacidade__contato-box">
                        <p><strong>Canal de Privacidade e Proteção de Dados:</strong></p>
                        <p>E-mail oficial: <a className="politica-privacidade__link" href="mailto:contato@viverespirita.com.br">contato@viverespirita.com.br</a></p>
                        <p>Atendimento gratuito mediante requisição do titular.</p>
                    </div>
                </section>

                <section className="politica-privacidade__secao">
                    <h2 className="politica-privacidade__subtitulo">9. Alterações nesta Política de Privacidade</h2>
                    <p className="politica-privacidade__texto">
                        Podemos revisar e atualizar esta Política periodicamente para refletir melhorias no site ou adequações a novas exigências 
                        legais. Sempre que realizarmos modificações relevantes, atualizaremos a data da "Última atualização" no início deste documento. 
                        Recomendamos a consulta periódica desta página.
                    </p>
                </section>

                <footer className="politica-privacidade__navegacao--rodape">
                    <BotaoVoltar />
                </footer>

            </div>
        </main>
    );
};

export default PoliticaPrivacidade;
